export default __webpack_public_path__ + "static/teamAug1-9c10e20bcc65e027182ffb66463c1946.jpeg";